// @flow
import {
  call,
  take,
  put,
} from 'redux-saga/effects'
import {
  actions as routerActions,
} from 'redux-router5'

import {sessionActions} from '../actions'
import {signIn} from '../../../firebase'

export function* signInEffect(): Effect {
  while (true) {
    const {payload: {username, password}} = yield take(sessionActions.signIn.id)
    yield put(sessionActions.setLoading(true))
    try {
      yield call(signIn, username, password)
      yield put(routerActions.navigateTo('home'))
    } catch (error) {
      yield put(sessionActions.setError(error.code))
    }
    yield put(sessionActions.setLoading(false))
  }
}
